import { render, staticRenderFns } from "./FailedTransactionDetails.vue?vue&type=template&id=5e91a72d&scoped=true&"
import script from "./FailedTransactionDetails.vue?vue&type=script&lang=ts&"
export * from "./FailedTransactionDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FailedTransactionDetails.vue?vue&type=style&index=0&id=5e91a72d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e91a72d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCardText,VCardTitle,VListItemTitle})
